import axios from "axios";
import { api } from "../../../services/apiHelpers";


export const GET_SIDEBAR_ITEMS_LIST = "GET_SIDEBAR_ITEMS_LIST";
export const ACTION_ERROR = "ACTION_ERROR";

export const getSidebarItemsList = () => dispatch => {
    return new Promise((resolve, reject) => {
        axios.get(api + "/Pages/sidebar").then(res => {
            if (res.data) {
                dispatch({
                    type: GET_SIDEBAR_ITEMS_LIST,
                    data: res.data.items
                });
                resolve(res.data);
            }
        }).catch(error => {
            return dispatch({
                type: ACTION_ERROR,
                data: error
            });
        });

    })

};

